import { Route, Routes } from 'react-router-dom';
import Home from '../layout/home';
import { DefaultFactory } from 'pages/factory/default-factory';
import { SectorFactory } from 'pages/factory/provider/sector-factory';
import { MessageFactory } from 'pages/factory/settings/message-factory';
import { HolidayFactory } from 'pages/factory/settings/holiday-factory';
import { ProviderFactory } from 'pages/factory/settings/provider-factory';
import { RegionalFactory } from 'pages/factory/provider/regional-factory';
import { FileLoadItemFactory } from 'pages/factory/file-load-item-factory';
import { AcessLogFactory } from 'pages/factory/settings/acess-log-factory';
import { ItemNoteFactory } from 'pages/factory/settings/item-note-factory';
import { FileLoadFactory } from 'pages/factory/settings/file-load-factory';
import { SyntheticFactory } from 'pages/factory/analysis/synthetic-factory';
import { IndicatorFactory } from 'pages/factory/analysis/indicator-factory';
import { QueryScrapFactory } from 'pages/factory/scrap/query-scrap-factory';
import { CurveTurnFactoryCompany } from 'pages/factory/settings/curve-turn-factory-company';
import { ReportScrapFactory } from 'pages/factory/scrap/report-scrap-factory';
import { FilterScrapFactory } from 'pages/factory/scrap/filter-scrap-factory';
import { ManagerialFactory } from 'pages/factory/analysis/managerial-factory';
import { AnalyticalFactory } from 'pages/factory/analysis/analytical-factory';
import { CommuniqueFactory } from 'pages/factory/settings/communique-factory';
import { CurveValueFactory } from 'pages/factory/settings/curve-value-factory';
import { CurveScoreFactory } from 'pages/factory/settings/curve-score-factory';
import { ManufacturerFactory } from 'pages/factory/settings/manufacturer-factory';
import { EqualizationFactory } from 'pages/factory/analysis/equalization-factory';
import { GenerateScrapFactory } from 'pages/factory/scrap/generate-scrap-factory';
import { ApprovalScrapFactory } from 'pages/factory/scrap/approval-scrap-factory';
import { ConfigurationFactory } from 'pages/factory/settings/configuration-factory';
import { OriginalItemsFactory } from 'pages/factory/provider/original-items-factory';
import { CorrelateItemFactory } from 'pages/factory/provider/correlate-item-factory';
import { FilialProviderFactory } from 'pages/factory/provider/filial-provider-factory';
import { OnlineConsultantFactoryV2 } from 'pages/factory/settings/online-consultant-factory-v2';
import ErrorAuthenticationTokenPage from 'pages/layout/error/error-authentication-token-page';
import { OriginalItemStatusFactory } from 'pages/factory/provider/original-item-status-factory';
import { QueryItemNetworkFactory } from 'pages/factory/scrap/query-item-network-factory';
import { ResetPasswordFactory } from 'pages/factory/safety/reset-password-factory';
import { UserFactoryV2 } from 'pages/factory/safety/user-factory-v2';
import { CurveTurnFactoryUser } from 'pages/factory/settings/curve-turn-factory-user';
import { CompanyGroupFactory } from 'pages/factory/safety/company-group-factory';
import { ChangeUserInternalFactory } from 'pages/factory/safety/change-user-internal-company-factory';
import { InfoFactory } from '../../pages/factory/settings/info-factory';
import { OrdinationFactory } from 'pages/factory/settings/ordination-factory';
import { ActiveCampaignsFactory } from 'pages/factory/analysis/active-campaigns-factory';
import { OrdersIntensionsForApprovalFactory } from 'pages/factory/analysis/orders-intentions-for-approval-factory';
import { FluxoAprovacaoPedidoOperadorFactory } from 'pages/factory/analysis/fluxo-aprovacao-pedido-operador-factory';
import { FluxoAprovacaoPedidoListaFactory } from 'pages/factory/analysis/fluxo-aprovacao-pedido-lista-factory';
import { OnlineConsultantAnalyticalFactory } from 'pages/factory/analysis/online-consultant-analytical-factory';
import { LogoutRoute } from 'pages/layout/safety/logout-route';

export function Private() {
  return (
    <Routes>
      <Route path="*" element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route path="/usuario" element={<UserFactoryV2 />} />
      <Route path="/setor" element={<SectorFactory />} />
      <Route path="/feriado" element={<HolidayFactory />} />
      <Route path="/mensagem" element={<MessageFactory />} />
      <Route path="/regional" element={<RegionalFactory />} />
      <Route path="/log-carga" element={<AcessLogFactory />} />
      <Route path="/file-load" element={<FileLoadFactory />} />
      <Route path="/sintetico" element={<SyntheticFactory />} />
      <Route path="/indicador" element={<IndicatorFactory />} />
      <Route path="/cadastrar/fornecedor" element={<ProviderFactory />} />
      <Route path="/analitico" element={<AnalyticalFactory hasHeader={true} />} />
      <Route path="/comanalisaranalitico" element={<OnlineConsultantAnalyticalFactory />} />
      <Route path="/analiticoconsultoronline" element={<AnalyticalFactory hasHeader={false} />} />
      <Route path="/gerencial" element={<ManagerialFactory />} />
      <Route path="/giro-curva-empresa" element={<CurveTurnFactoryCompany />} />
      <Route path="/giro-curva-usuario" element={<CurveTurnFactoryUser />} />
      <Route path="/pagina-padrao" element={<DefaultFactory />} />
      <Route path="/valor-curva" element={<CurveValueFactory />} />
      <Route path="/comunicacao" element={<CommuniqueFactory />} />
      <Route path="/fabricante" element={<ManufacturerFactory />} />
      <Route path="/filtro-scrap" element={<FilterScrapFactory />} />
      <Route path="/equalizacao" element={<EqualizationFactory />} />
      <Route path="/observacao-item" element={<ItemNoteFactory />} />
      <Route path="/gerar-scrap" element={<GenerateScrapFactory />} />
      <Route path="/consulta-scrap" element={<QueryScrapFactory />} />
      <Route path="/consulta-item-rede" element={<QueryItemNetworkFactory />} />
      <Route path="/pontuacao-curva" element={<CurveScoreFactory />} />
      <Route path="/cadastrar/configuracao" element={<ConfigurationFactory />} />
      <Route path="/relatorio-scrap" element={<ReportScrapFactory />} />
      <Route path="/itens-correlato" element={<CorrelateItemFactory />} />
      <Route path="/aprovacao-scrap" element={<ApprovalScrapFactory />} />
      <Route path="/itens-originais" element={<OriginalItemsFactory />} />
      <Route path="/filial-fornecedor" element={<FilialProviderFactory />} />
      <Route path="/config-consultor-online-v2" element={<OnlineConsultantFactoryV2 />} />
      <Route path="/carregar-arquivos-fornecedor" element={<FileLoadItemFactory />} />
      <Route path="/itens-originais-status" element={<OriginalItemStatusFactory />} />
      <Route path="/reset-password" element={<ResetPasswordFactory />} />
      <Route path="/grupo-empresa" element={<CompanyGroupFactory />} />
      <Route path="/troca-usuario-interno-empresa" element={<ChangeUserInternalFactory />} />
      <Route path="/tutorial" element={<InfoFactory />} />
      <Route path="/ordenacao" element={<OrdinationFactory />} />
      <Route path="/campanhas-ativas" element={<ActiveCampaignsFactory />} />
      <Route path="/pedidos" element={<OrdersIntensionsForApprovalFactory />} />
      <Route path="/fluxo-aprovacao-pedido" element={<FluxoAprovacaoPedidoListaFactory />} />
      <Route path="/fluxo-aprovacao-pedido/:idPedido" element={<FluxoAprovacaoPedidoOperadorFactory />} />

      <Route path="/error-token" element={<ErrorAuthenticationTokenPage />} />
      <Route path="/logout" element={<LogoutRoute />} />
    </Routes>
  );
}

export default Private;
